module.exports = __webpack_public_path__ + "img/iMac24inch@2x.9066a799.png";